// test359
(359 && 0);
